import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { NotFoundGuard } from './services/404.guard';
import { ConsultWorkplaceGuard } from './services/consult-workplace.guard';
import { NEW_CLIENT_ROUTE, CLIENT_PEEK_ROUTE, DASHBOARD_ROUTE, CLIENT_LIST_ROUTE, DRAFT_TYPE_SELECT_ROUTE, CLIENT_PICKER_ROUTE, WITHDRAWAL_AVAILABLE_CLIENTS_ROUTE, WITHDRAWAL_FORM_ROUTE, WITHDRAWAL_CHECK_ROUTE, WITHDRAWAL_COMMENT_ROUTE, INVESTMENT_GOAL_ROUTE, CONSULT_DRAFT_DETAIL_ROUTE, WORKPLACE_INVESTMENT_DETAIL, DRAFT_TEMPLATES_ROUTE } from './shared/constants';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'oauth/bcas/callback',
    loadChildren: () => import('./modules/oauth/oauth.module').then(m => m.OauthModule)
  },
  {
    path: 'oauth/bcas/consult-callback',
    loadChildren: () => import('./modules/oauth/oauth.module').then(m => m.OauthModule)
  },
  {
    path: DASHBOARD_ROUTE,
    loadChildren: () => import('./modules/workplace-summary/workplace-summary.module').then(m => m.WorkplaceSummaryModule),
  },
  {
    path: WORKPLACE_INVESTMENT_DETAIL + '/:investmentId',
    loadChildren: () => import('./modules/workplace-investment-detail/workplace-investment-detail.module').then(m => m.WorkplaceInvestmentDetailModule),
  },
  {
    path: CLIENT_LIST_ROUTE,
    loadChildren: () => import('./modules/workplace-clients/workplace-clients.module').then(m => m.WorkplaceClientsModule),
  },
  {
    path: 'expiring-contracts',
    loadChildren: () => import('./modules/expiring-contracts/expiring-contracts.module').then(m => m.ExpiringContractsModule),
  },
  {
    path: 'missing-regular',
    loadChildren: () => import('./modules/missing-regular/missing-regular.module').then(m => m.MissingRegularModule),
  },
  {
    path: NEW_CLIENT_ROUTE,
    loadChildren: () => import('./modules/new-client/new-client.module').then(m => m.NewClientModule),
  },
  {
    path: 'new-draft',
    loadChildren: () => import('./modules/workplace-clients/workplace-clients.module').then(m => m.WorkplaceClientsModule),
  },
  {
    path: CLIENT_PICKER_ROUTE,
    loadChildren: () => import('./modules/new-draft/new-draft.module').then(m => m.NewDraftModule),
  },
  {
    path: DRAFT_TYPE_SELECT_ROUTE,
    loadChildren: () => import('./modules/draft-type-select/draft-type-select.module').then(m => m.DraftTypeSelectModule),
  },
  {
    path: WITHDRAWAL_AVAILABLE_CLIENTS_ROUTE,
    loadChildren: () => import('./modules/withdrawal-available-clients/withdrawal-available-clients.module').then(m => m.WithdrawalAvaialableClientsModule),
  },
  {
    path: WITHDRAWAL_FORM_ROUTE,
    loadChildren: () => import('./modules/regular-withdrawal-form/regular-withdrawal-form.module').then(m => m.RegularWithdrawalFormModule),
  },
  {
    path: 'regular-withdrawal-send',
    loadChildren: () => import('./modules/regular-withdrawal-send/regular-withdrawal-send.module').then(m => m.RegularWithdrawalSendModule),
  },
  {
    path: WITHDRAWAL_COMMENT_ROUTE,
    loadChildren: () => import('./modules/regular-withdrawal-comment/regular-withdrawal-comment.module').then(m => m.RegularWithdrawalCommentModule),
  },
  {
    path: WITHDRAWAL_CHECK_ROUTE,
    loadChildren: () => import('./modules/regular-withdrawal-check/regular-withdrawal-check.module').then(m => m.RegularWithdrawalCheckModule),
  },
  {
    path: 'client-detail',
    loadChildren: () => import('./modules/client-detail/client-detail.module').then(m => m.ClientDetailModule)
  },
  {
    path: INVESTMENT_GOAL_ROUTE,
    loadChildren: () => import('./modules/investment-goal/investment-goal.module').then(m => m.InvestmentGoalModule)
  },
  {
    path: 'investment-type',
    loadChildren: () => import('./modules/investment-type/investment-type.module').then(m => m.InvestmentTypeModule)
  },
  {
    path: 'consult-strategy-pick',
    loadChildren: () => import('./modules/consult-strategy-pick/consult-strategy-pick.module').then(m => m.ConsultStrategyPickModule),
    canActivate: [ConsultWorkplaceGuard],
  },
  {
    path: 'suggest-strategy',
    loadChildren: () => import('./modules/suggest-strategy/suggest-strategy.module').then(m => m.SuggestStrategyModule)
  },
  {
    path: 'suggest-strategy/:modelStrategyId',
    loadChildren: () => import('./modules/suggest-strategy/suggest-strategy.module').then(m => m.SuggestStrategyModule)
  },
  {
    path: 'suggest-strategy/draft/:draftTemplateId',
    loadChildren: () => import('./modules/suggest-strategy/suggest-strategy.module').then(m => m.SuggestStrategyModule)
  },
  {
    path: 'suggest-portfolio',
    loadChildren: () => import('./modules/suggest-portfolio/suggest-portfolio.module').then(m => m.SuggestPortfolioModule)
  },
  {
    path: 'consult-comment',
    loadChildren: () => import('./modules/consult-comment/consult-comment.module').then(m => m.ConsultCommentModule)
  },
  {
    path: 'consult-suggest-check',
    loadChildren: () => import('./modules/consult-suggest-check/consult-suggest-check.module').then(m => m.ConsultSuggestCheckModule)
  },
  {
    path: 'consult-suggestment-sent',
    loadChildren: () => import('./modules/consult-suggestment-sent/consult-suggestment-sent.module').then(m => m.ConsultSuggestmentSentModule)
  },
  {
    path: CONSULT_DRAFT_DETAIL_ROUTE,
    loadChildren: () => import('./modules/consult-draft-detail/consult-draft-detail.module').then(m => m.ConsultDraftDetailModule)
  },
  {
    path: 'sent-investment-drafts',
    loadChildren: () => import('./modules/sent-investment-drafts/sent-investment-drafts.module').then(m => m.SentInvestmentDraftsModule),
  },
  {
    path: CLIENT_PEEK_ROUTE,
    loadChildren: () => import('./modules/client-peek/client-peek.module').then(m => m.ClientPeekModule)
  },
  {
    path: 'draft-template',
    loadChildren: () => import('./modules/draft-template/draft-template.module').then(m => m.DraftTemplateModule),
  },
  {
    path: DRAFT_TEMPLATES_ROUTE,
    loadChildren: () => import('./modules/draft-templates/draft-templates.module').then(m => m.DraftTemplatesModule)
  },
  {
    path: '**',
    component: NotFoundComponent,
    canActivate: [NotFoundGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        onSameUrlNavigation: 'reload',
        paramsInheritanceStrategy: 'emptyOnly',
      }
    ),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
